import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Icon, IconComponent } from '@wam/components';

@Component({
  selector: 'cl-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent],
})
export class NavItemComponent {
  readonly icon = input<Icon>();
  readonly newItemsCount = input<number>();
  readonly selected = input<boolean>();
  readonly disabled = input<boolean>();
}
